/* External */
import { Map } from 'immutable';
import identity from 'lodash-es/identity';

/* ActionTypes */
import { ADD_TO_ENTITIES, CLEAN_ALL_ENTITIES, CLEAN_ONE_ENTITY } from '../actionTypes';

function addEntities(state, entities, EntityModel) {
  if (!entities) return state;

  const entitiesValues = Object.values(entities);
  return state.withMutations((mutableState) => {
    for (const newValue of entitiesValues) {
      const newEntity = new EntityModel().setAll(newValue);
      const { normalId } = newEntity;
      const currentEntity = mutableState.get(normalId);
      mutableState.set(normalId, currentEntity ? currentEntity.setAll(newValue) : newEntity);
    }
  });
}

export function generateEntityReducer(
  entityActionTypes,
  EntityModel,
  otherActionsReducer = identity,
) {
  const { entityName } = EntityModel;
  const initialState = Map();

  return function generatedEntityReducer(state = initialState, action = {}) {
    const { type, payload } = action;

    switch (type) {
      case entityActionTypes.ADD: {
        return addEntities(state, payload, EntityModel);
      }
      case ADD_TO_ENTITIES: {
        const entities = payload[entityName];
        return addEntities(state, entities, EntityModel);
      }
      case CLEAN_ONE_ENTITY: {
        if (entityName === payload) {
          return initialState;
        }

        return otherActionsReducer(state, action);
      }
      case entityActionTypes.CLEAN:
      case CLEAN_ALL_ENTITIES: {
        return initialState;
      }
      default: {
        return otherActionsReducer(state, action);
      }
    }
  };
}
